import React from "react";
import SEO from "../components/SEO";
import { MaskLineScroll } from "../components/Reveal";
import { BRAND } from "../lib/brand";

export default function Events() {
  return (
    <>
      <SEO
        title="Events & News — ProForm Paint & Body"
        description="Drift meets, shop announcements, and featured builds from ProForm Paint & Body."
        canonical={`https://${BRAND.domain}/events`}
      />
      <section className="pt-32 md:pt-40 pb-24">
        <div className="wrap">
          <div className="label mb-3">— Events · 001</div>
          <h1 className="font-display uppercase text-5xl md:text-8xl leading-[0.88] tracking-tight max-w-4xl">
            <MaskLineScroll>Drift meets,</MaskLineScroll>
            <MaskLineScroll delay={0.08}>build updates &amp; <span className="text-proform-red">news</span>.</MaskLineScroll>
          </h1>
          <p className="mt-8 text-chrome-300 max-w-2xl text-lg leading-relaxed">
            The events log is being set up. In the meantime, live shop updates, drift-event coverage, and personal-build progress are posted to <a className="text-proform-red hover:underline" target="_blank" rel="noreferrer" href={BRAND.instagramUrl}>@{BRAND.instagramHandle}</a>.
          </p>

          <div className="mt-16 grid md:grid-cols-3 gap-4 md:gap-6">
            {[
              ["Drift Coverage", "Local drift days & regional meets ProForm attends or sponsors."],
              ["Shop Announcements", "Openings, capacity changes, project drops."],
              ["Featured Builds", "Milestone updates on Cody's personal and customer builds."],
            ].map(([t, d], i) => (
              <div key={t} className="card p-6 md:p-8">
                <div className="label">— Category · 0{i + 1}</div>
                <div className="font-display uppercase text-2xl mt-4">{t}</div>
                <p className="mt-3 text-chrome-300 text-sm">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
